import { Injectable } from "@angular/core";

import { ApiService } from "./api.service";
import { MemberDetails } from "../shared/interfaces/member-details";
import { PicketRecordDetails } from "../shared/interfaces/picket-member-details";

@Injectable({
  providedIn: "root",
})
export class PicketService {
  constructor(private apiService: ApiService) {}

  async getPicketMemberInfo(strikeId: string, filter: string) {
    const response = await this.apiService.get<MemberDetails>(
      "/api/strikemembers/strike/" + strikeId + "/memberId/" + filter
    );
    return response;
  }

  async getLatestSignIn(strikeId: string, memberId: string) {
    const response = await this.apiService.get<PicketRecordDetails>(
      "/api/strikewalk/strike/" + strikeId + "/memberid/" + memberId + "/latestsignin"
    );

    return response;
  }

  async addSignIn(newSignIn: PicketRecordDetails) {
    const response = await this.apiService.post("/api/strikewalk/add", newSignIn);
    return response;
  }
  
  async addSignOut(picketSignOut: PicketRecordDetails) {
    const response = await this.apiService.post("/api/strikewalk/update", picketSignOut);
    return response;
  }

  async addManual(newRecord: PicketRecordDetails){
    const response = await this.apiService.post("/api/strikewalk/addManual", newRecord)
    return response
  }
}
